/* istanbul ignore file */
export const alertTheme = ({ palette: { background }, shadows, spacing: { unit } }) => ({
  background: background.normal,
  border: `${unit / 8}px solid transparent`,
  borderRadius: unit / 2,
  boxShadow: `${unit / 8}px ${unit / 8}px ${unit / 2}px ${unit / 4}px ${shadows.normal}`
});

const styles = ({ alert, breakpoints, palette: { secondary, success }, spacing: { unit } }) => ({
  alert: {
    ...alert,
    fontSize: 16,
    color: '#333333',
    marginBottom: unit * 3,
    borderLeft: '5px solid',
    display: 'flex',
    '&.alert-positive': {
      borderLeftColor: success.normal,
      backgroundColor: '#FFF'
    },
    '&.alert-success, &.alert-info': {
      borderLeftColor: '#00dfeb',
      backgroundColor: '#FFF'
    },
    '&.alert-error, &.alert-warning': {
      borderLeftColor: '#f15a24',
      backgroundColor: '#FFF'
    },
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      overflowX: 'auto'
    }
  },
  close: {
    order: 3,
    opacity: 1,
    float: 'right',
    marginTop: 9,
    cursor: 'pointer',
    '& svg': {
      fill: '#333333'
    }
  },
  message: {
    fontSize: unit * 1.5,
    display: 'flex',
    flexDirection: 'column',
    padding: `${unit * 1.3}px 0 0`,
    width: '100%',
    '& table': {
      margin: `0 ${unit * 2}px`
    }
  },
  inline: {
    display: 'inline-block',
    verticalAlign: 'inherit',
    paddingRight: unit
  },
  checkmarkWrapper: {
    fontSize: 0,
    paddingRight: unit * 1.75,
    verticalAlign: 'top',
    '& svg': {
      width: unit * 4,
      height: unit * 4,
      fill: '#cccccc'
    }
  },
  caretWrapper: {
    display: 'flex',
    marginTop: unit,
    '& svg': {
      width: unit * 2,
      height: unit * 2,
      fill: '#ccc',
      cursor: 'pointer',
      marginTop: unit * 0.25
    }
  },
  guidMsg: {
    display: 'flex',
    color: secondary.normal,
    fontSize: unit * 1.625,
    paddingTop: unit
  },
  preventOverflow: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    wordBreak: 'break-word',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      display: 'block'
    }
  }
});

export default styles;
